import { getEnv } from '@ruguoapp/jkfe-env';

// import { v4 as uuid } from 'uuid'
var removeBase64Perfix = function (str) { return str.replace(/^data:.*;base64,/, function () { return ''; }); };
var actionId = 0;
var readFileAsync = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
var isBase64URL = function (url) {
    return url.indexOf('data:') !== -1 && url.indexOf('base64') !== -1;
};
// 不论参数是dataUrl还是图片的cdn url还是File 最终都返回base64
var toDataURL = function (urlOrFile) {
    if (typeof urlOrFile === 'string') {
        if (isBase64URL(urlOrFile)) {
            return Promise.resolve(removeBase64Perfix(urlOrFile));
        }
        else {
            return fetch(urlOrFile).then(function (response) {
                return response
                    .blob()
                    .then(function (blob) { return readFileAsync(blob); })
                    .then(function (dataUrl) { return removeBase64Perfix(dataUrl); });
            });
        }
    }
    else {
        return readFileAsync(urlOrFile).then(function (dataUrl) { return removeBase64Perfix(dataUrl); });
    }
};
function getActionId() {
    actionId += 1;
    return "" + actionId;
}
// export const getShareConfig = (
//   config: ShareConfigSchema,
//   key: keyof Required<ShareConfigSchema>,
// ) => {
//   if (key in config) {
//     return config[key] as Partial<ShareConfigSchema>
//   } else if ('wechat' in config && key in config.wechat) {
//     return config.wechat[key] as Partial<Pick<ShareConfigSchema, 'wechat'>>
//   } else if ('qq' in config && key in config.qq) {
//     return config.qq[key] as Partial<Pick<ShareConfigSchema, 'qq'>>
//   } else if ('weibo' in config && key in config.weibo) {
//     return config.weibo[key] as Partial<Pick<ShareConfigSchema, 'weibo'>>
//   } else {
//     return ''
//   }
// }

var JKH = {};
var sdkReady = false;
var inited = false;
var debug = false;
var actionQueue = [];
var callbacks = {
    rg_back_pressed: function () {
        document.dispatchEvent(new Event('JikeHybridBackPressed'));
    },
};
/**
 * 初始化`JikeHybrid`对象
 * @returns 返回`Promise`代表初始化是否成功，如果超过两秒未成功则失败。
 */
var onSDKReady = function () {
    sdkReady = true;
    actionQueue.map(function (action) {
        return JKH.nativeDispatch && JKH.nativeDispatch(action);
    });
    actionQueue.length = 0;
};
var init = function () {
    inited = true;
    if (typeof window === 'undefined') {
        return null;
    }
    window.JikeHybrid = window.JikeHybrid || {};
    JKH = window.JikeHybrid;
    JKH.webDispatch = function (action) {
        if (callbacks[action.type]) {
            callbacks[action.type](action.error, action.payload, (action.callback || {}).context);
        }
    };
    if (debug) {
        // tslint:disable no-console
        console.log('[if-jssdk]: JKH created');
    }
    if (JKH.nativeDispatch) {
        onSDKReady();
        return Promise.resolve();
    }
    else {
        return new Promise(function (resolve, reject) {
            // iOS客户端应当在nativeDispatch注入后注入以下代码
            // var event = new Event('JikeHybridBridgeReady');
            // document.dispatchEvent(event);
            // 由于实现机制的不同，Android可以保证nativeDispatch一定存在
            document.addEventListener('JikeHybridBridgeReady', function () {
                if (debug) {
                    // tslint:disable no-console
                    console.info("[if-jssdk]: actionQueue length is " + actionQueue.length);
                }
                onSDKReady();
                if (debug) {
                    // tslint:disable no-console
                    console.info('[if-jssdk]: JKH ready');
                }
                resolve();
            }, false);
        });
    }
};
var nativeDispatch = function (action) {
    if (debug) {
        // tslint:disable no-console
        console.info(action.slice(0, 1000));
    }
    if (sdkReady && JKH.nativeDispatch) {
        JKH.nativeDispatch(action);
    }
    else {
        // 如果sdk未准备好，先将action推入任务队列
        actionQueue.push(action);
        // 如果发现还没初始化过sdk，初始化它
        if (inited === false) {
            init();
        }
    }
};
var callNative = function (type, payload, callback) {
    var callbackId = getActionId();
    var action = {
        type: type,
        payload: payload !== null && payload !== void 0 ? payload : {},
        callback: callback !== null && callback !== void 0 ? callback : {
            actionType: callbackId,
            context: {},
        },
    };
    var promise = new Promise(function (resolve, reject) {
        callbacks[callbackId] = function (error, pl, context) {
            delete callbacks[callbackId];
            if (error) {
                reject({ payload: pl, context: context });
            }
            else {
                resolve({ payload: pl, context: context });
            }
        };
    });
    nativeDispatch(JSON.stringify(action));
    return promise;
};
var callNativeWithoutResult = function (type, payload, callback) {
    var action = {
        type: type,
        payload: payload !== null && payload !== void 0 ? payload : {},
        callback: callback,
    };
    nativeDispatch(JSON.stringify(action));
    return Promise.resolve();
};
var getCallbacks = function () { return callbacks; };
var addCallback = function (key, cb) {
    if (inited === false) {
        init();
    }
    callbacks[key] = cb;
};
var checkCallbackExist = function (key) {
    return callbacks[key];
};
var enableDebug = function () {
    debug = true;
};

var checkAppMap = {
    Alipay: {
        iOS: 'alipay://',
        Android: 'com.eg.android.AlipayGphone',
    },
    WeChat: {
        iOS: 'wechat://',
        Android: 'com.tencent.mm',
    },
};

var checkIfAppIsInstalled = function (checkAppType) {
    var system = getEnv().os.name;
    var application = checkAppMap[checkAppType][system];
    return callNative('rg_check_if_app_is_installed', { application: application }).then(function (_a) {
        var payload = _a.payload;
        return payload.result;
    });
};
var pickUser = function () {
    // 调起原生 @ 页面，待用户选择指定用户后，返回选定用户的全部信息
    return callNative('rg_pick_user').then(function (_a) {
        var payload = _a.payload;
        return payload;
    });
};
var refreshData = function (key) {
    return callNative('rg_refresh_data', {
        key: key,
    }).then(function (_a) {
        var payload = _a.payload;
        return payload.success;
    });
};
var requestKingcardStatus = function (phoneNumber) {
    return callNative('request_kingcard_status', {
        phoneNumber: phoneNumber,
    });
};
var activateKingcardManually = function () {
    return callNative('rg_kingcard_activate_manually');
};

var transferBinaryFile = function (urlOrFile) {
    return toDataURL(urlOrFile).then(function (file) {
        return callNative('rg_transfer_binary_file', { file: file }).then(function (_a) {
            var fileId = _a.payload.fileId;
            return fileId;
        });
    });
};
var saveFileToCameraRoll = function (urlOrFile) {
    return transferBinaryFile(urlOrFile).then(function (fileId) {
        return callNative('rg_save_file_to_camera_roll', { fileId: fileId });
    });
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var nativeLog = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var logString = '';
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        if (typeof arg === 'object') {
            logString += JSON.stringify(arg) + " ";
        }
        else {
            logString += arg;
        }
    }
    // iOS 会打印 dispatch 的内容，需要过滤掉 rg_log 的 dispatch，否则会无限 log
    // 以及 web debug 工具的 log 也要过滤
    if (logString.indexOf('rg_log') !== -1) {
        return;
    }
    callNativeWithoutResult('rg_log', { content: logString });
};
var enableNativeLogger = function () {
    var _this = this;
    var oldConsole = {};
    var allowType = ['log', 'warn', 'error', 'info'];
    var _loop_1 = function (key) {
        oldConsole[key] = window.console[key];
        window.console[key] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            oldConsole[key].apply(window.console, args);
            nativeLog.apply(_this, __spreadArray([key], args));
        };
    };
    for (var _i = 0, allowType_1 = allowType; _i < allowType_1.length; _i++) {
        var key = allowType_1[_i];
        _loop_1(key);
    }
};

var shareConfig = {};
var configShare = function (config) {
    shareConfig = __assign(__assign({}, shareConfig), config);
};
// 直接返回整个客户端给的结果，不再做处理 see:https://github.com/ruguoapp/jike-js-sdk/issues/33
// @TODO: tweak callNative generic
var getShareConfig = function (config, key) {
    var _a;
    if (key in config) {
        return config[key];
    }
    else if ('wechat' in config && key in config.wechat) {
        return config.wechat[key];
    }
    else if ('qq' in config && key in config.qq) {
        return config.qq[key];
    }
    else if ('weibo' in config && key in config.weibo) {
        return config.weibo[key];
    }
    else {
        return (_a = shareConfig[key]) !== null && _a !== void 0 ? _a : '';
    }
};
function getBasicKeys(config) {
    var basicKeys = {};
    var keys = ['title', 'desc', 'imageUrl', 'linkUrl'];
    keys.forEach(function (key) {
        basicKeys[key] = getShareConfig(config, key) || '';
    });
    return basicKeys;
}
var share = function (config) {
    if (config === void 0) { config = {}; }
    var basicKeys = getBasicKeys(config);
    var shareObject = __assign({ buttons: config.buttons }, basicKeys);
    for (var _i = 0, _a = config.buttons; _i < _a.length; _i++) {
        var button = _a[_i];
        shareObject[button] = __assign(__assign({}, basicKeys), config[button]);
    }
    return callNative('rg_share', shareObject);
};

var alert = function (config) {
    return callNative('rg_alert', config).then(function (_a) {
        var payload = _a.payload;
        return payload;
    });
};
var showToast = function (message, duration, status) {
    if (duration === void 0) { duration = 2000; }
    if (status === void 0) { status = 'success'; }
    callNativeWithoutResult('rg_toast', { message: message, duration: duration, status: status });
};
var openWebview = function (url, config) {
    var urlObject = new URL(url);
    var urlSearchParams = urlObject.searchParams;
    for (var key in config) {
        if (config.hasOwnProperty(key)) {
            urlSearchParams.append(key, config[key]);
        }
    }
    callNativeWithoutResult('rg_open_webview', {
        url: urlObject.toString(),
    });
};
var closeWebview = function () {
    callNativeWithoutResult('rg_close');
};
/**
 * iOS only
 */
// const prepareHapticFeedback = (style: HapticFeedbackType = 'lightImpact') => {
//   callNativeWithoutResult('rg_haptic_feedback_prepare', { style })
// }
/**
 * ⚠️ Android上只有duration生效，iOS上只有styles生效
 *
 * 命名为`nativeVibrate`与`Navigator.vibrate` 相区分
 */
var triggerNativeVibrate = function (style, duration) {
    if (style === void 0) { style = 'lightImpact'; }
    if (duration === void 0) { duration = 500; }
    // fix iOS bug, see detail https://github.com/ruguoapp/jike-js-sdk/pull/14#pullrequestreview-173818973
    callNativeWithoutResult('rg_haptic_feedback_prepare', { style: style });
    callNativeWithoutResult('rg_haptic_feedback_trigger', {
        duration: duration,
        style: style,
    });
};
var uiConfig = {};
var setUIConfig = function (config) {
    var finalConfig = __assign(__assign({}, uiConfig), config);
    for (var item in finalConfig) {
        if (finalConfig.hasOwnProperty(item)) {
            finalConfig[item] = "" + finalConfig[item];
            if (item.indexOf('Color') > -1) {
                finalConfig[item] = finalConfig[item].toUpperCase();
            }
        }
    }
    callNativeWithoutResult('rg_webview_ui_config', finalConfig);
};
/**
 * 调用APP允许通知弹窗
 * @param config
 */
var notificationPermission = function (config) {
    callNativeWithoutResult('rg_notification_permission', config);
};

var login = function (config) {
    if (config.title === '') {
        delete config.title;
    }
    var finalConfig = __assign({ buttons: [] }, config);
    return callNative('rg_login', finalConfig);
};
var logout = function () {
    return callNativeWithoutResult('rg_logout');
};
var getRequestHeaders = function (forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return callNative('request_headers', { forceRefresh: forceRefresh }).then(function (res) { return res.payload; });
};

export { activateKingcardManually, addCallback, alert, callNative, callNativeWithoutResult, checkCallbackExist, checkIfAppIsInstalled, closeWebview, configShare, enableDebug, enableNativeLogger, getCallbacks, getRequestHeaders, init, login, logout, nativeDispatch, nativeLog, notificationPermission, openWebview, pickUser, refreshData, requestKingcardStatus, saveFileToCameraRoll, setUIConfig, share, showToast, transferBinaryFile, triggerNativeVibrate };
